// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b3412e39","511":"18c38499","598":"20aa11c7","787":"b0cb850a"}[chunkId] + ".chunk.js";
};